import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrright",
  "use": "icon-arrright-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrright\"><defs><style type=\"text/css\"></style></defs><path d=\"M505.6 492.8L505.6 185.6l428.8 307.2-428.8 300.8z\" p-id=\"5831\" /><path d=\"M128 492.80000001L128 185.60000001l428.8 307.19999999-428.8 300.8z\" p-id=\"5832\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol